// import Main from './Main'
import ListaVistoriadores from './components/ListaVistoriadores'

export default [
  // { path: '/vistoriadores', component: Main, name: 'vistoriadores.main' },
  {path: '/vistoriadores/lista', component: ListaVistoriadores, name: 'vistoriadores.lista'}
]
